import { format } from 'date-fns'

import { transformToReact } from '../format/transformToRC'

const formatDate = (data) => format(data, 'MMMM d, yyy')

const allPostConfigurator = (latestPost) =>
  latestPost.map((item) => ({
    id: item.node.id,
    imgSrc: `https:${item.node.thumb.file.url}`,
    data: formatDate(new Date(item.node.date)),
    title: transformToReact(item.node['titleEn'].raw),
    titleRu: transformToReact(item.node['titleRu'].raw),
    href: `/blog/${item.node.categoryEn.toLowerCase()}/${item.node.slug}`,
    description: transformToReact(item.node['bodyEn'].raw).substring(0, 300), // 0 300
    descriptionRu: transformToReact(item.node['bodyRu'].raw).substring(0, 300), // 0 300
    category: item.node.categoryEn,
    categoryRu: item.node.categoryRu,
  }))

const onePostPageConfigurator = (pageContext) => ({
  title: transformToReact(pageContext.data['titleEn'].raw),
  body: transformToReact(pageContext.data['bodyEn'].raw),
  titleRu: transformToReact(pageContext.data['titleRu'].raw),
  bodyRu: transformToReact(pageContext.data['bodyRu'].raw),
  peopleName: pageContext.data.postedByEn,
  data: formatDate(new Date(pageContext.data.date)),
  link: `https://it-justice.com/blog/${pageContext.data.categoryEn.toLowerCase()}/${
    pageContext.data.slug
  }`,
  imgSrc: `https:${pageContext.data.header.file.url}`,
  thumb: `https:${pageContext.data.thumb.file.url}`,
  slug: pageContext.data.slug,
  avatar: `https:${pageContext.data.avatar.file.url}`,
  titleForSeo: pageContext.data.titleForSeo,
  titleForSeoRu: pageContext.data.titleForSeoRu,
  category: pageContext.data.categoryEn.toLowerCase(),
  categoryRu: pageContext.data.categoryRu.toLowerCase(),
  authorName: pageContext.data.postedBy,
})

const filteredPostsConfigurator = (posts) =>
  posts.map((item) => ({
    id: item.id,
    imgSrc: `https:${item.thumb.file.url}`,
    data: formatDate(new Date(item.date)),
    title: transformToReact(item['titleEn'].raw),
    titleRu: transformToReact(item['titleRu'].raw),
    href: `/blog/${item.categoryEn.toLowerCase()}/${item.slug}`,
    description: transformToReact(item['bodyEn'].raw).substring(0, 300), // 0 300
    descriptionRu: transformToReact(item['bodyRu'].raw).substring(0, 300), // 0 300
    category: item.categoryEn,
    categoryRu: item.categoryRu,
  }))

export {
  onePostPageConfigurator,
  allPostConfigurator,
  filteredPostsConfigurator,
}
